/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon16Solid = forwardRef('LogoFigmaIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 3a2 2 0 0 1 2-2h2v4H6a2 2 0 0 1-2-2Z" }),
        React.createElement("path", { d: "M4 8a2 2 0 0 1 2-2h2v4H6a2 2 0 0 1-2-2Z" }),
        React.createElement("path", { d: "M12.75 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M6 11a2 2 0 1 0 2 2v-2H6Z" }),
        React.createElement("path", { d: "M11 1H9v4h2a2 2 0 1 0 0-4Z" })));
});
